var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"OAModal"},[_c('el-dialog',{attrs:{"visible":_vm.visibleCopy,"width":_vm.width,"lock-scroll":true,"close-on-click-modal":false,"title":_vm.title,"top":"5vh"},on:{"update:visible":function($event){_vm.visibleCopy=$event},"close":_vm.onCancel}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ecb7da2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OAModal/OAModal.vue
// module id = null
// module chunks = 